import React from 'react'


const Empty = ({ className = "", children, style }) => {
    return(
        <div className={`Space__Empty ${className}`} style={style}>
            <p className='spp-font-text-lg spp-c-dark spp-o-xl'>
                {children}
            </p>
        </div>
    )
}

export default Empty